import { IServiceLookupDto } from '@shared/api';
import { SelectOption } from '@shared/UI';

export const mapLookupsToSelectOptions = (field: string, lookups: IServiceLookupDto[]): SelectOption[] | null => {
    const currentLookup = lookups.find((lookup) => lookup.name === field);
    const options = currentLookup?.items.map((item) => {
        return {
            label: item?.displayName || item?.name,
            value: Number.isInteger(item?.id) ? item?.id : item?.name,
        };
    });
    return options || null;
};
